import styled from '@emotion/styled'
import type { FC } from 'react'

import Typography from '@segment/matcha/components/Typography'

import AccordionBase, * as Accordion from '@segment/matcha/recipes/Accordion'

import type { Faq as FaqType } from '@segment/api/types/resource'

import { useActiveState } from '@segment/utils/useActiveState'

const copy = {
  heading: `Frequently asked questions`,
}

interface FaqProps {
  data: FaqType[]
}
const Faq: FC<FaqProps> = ({ data }) => {
  const items = new Array(data.length).fill(false)
  const { activeItems, toggle } = useActiveState(items, {
    allowMultipleActive: true,
  })
  return (
    <Wrapper>
      <Heading variant="h2">{copy.heading}</Heading>
      <Accordion.JsonLdFaq
        data={data.map(({ answer, question }) => {
          return {
            question,
            answer,
          }
        })}
      />
      {activeItems.map((active, index) => (
        <AccordionBase key={`item-${index}`}>
          <Accordion.Header onClick={() => toggle(index)}>
            <Accordion.TitleWrapper>
              <Accordion.Title opened={active}>{data[index].question}</Accordion.Title>
            </Accordion.TitleWrapper>
            <Accordion.Icon opened={active} />
          </Accordion.Header>
          <Accordion.Body>
            {active && (
              <Accordion.ContentWrapper>
                <Accordion.Text>{data[index].answer}</Accordion.Text>
              </Accordion.ContentWrapper>
            )}
          </Accordion.Body>
        </AccordionBase>
      ))}
    </Wrapper>
  )
}

export default Faq

const Wrapper = styled.div`
  overflow-y: hidden;

  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    margin-top: 60px;
  }

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    margin-top: 98px;
  }
`

const Heading = styled(Typography)`
  padding-bottom: 16px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding-bottom: 24px;
  }

  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    padding-bottom: 32px;
  }
`
